var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.14,
    height: 13,
    viewBox: "0 0 16 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1026.811 -628.016)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1027.311 628.516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.687,78.441a1.878,1.878,0,0,0-1.326-1.326A44.819,44.819,0,0,0,7.5,76.8a44.82,44.82,0,0,0-5.86.314A1.879,1.879,0,0,0,.313,78.441a20.955,20.955,0,0,0,0,7.221,1.879,1.879,0,0,0,1.326,1.326A44.837,44.837,0,0,0,7.5,87.3a44.837,44.837,0,0,0,5.86-.313,1.878,1.878,0,0,0,1.326-1.326A19.515,19.515,0,0,0,15,82.051,19.516,19.516,0,0,0,14.687,78.441Z",
    transform: "translate(0 -76.801)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.8,183.7l3.9-2.25-3.9-2.25Z",
    transform: "translate(828.514 452.315)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fd7b9d9b01008d514dbd08430c295d33.svg";
export { ForwardRef as ReactComponent };